import React from 'react'

function PageTitle({title}) {
    return (
        <h1 className="text-xl uppercase">
            {title}
        </h1>
    )
}

export default PageTitle